import type { Module } from 'vuex';
import { LanguagePage } from '@/types/LanguagePage';
import {RootState} from "@/store";

export interface LanguagePagesState {
  languagePages: LanguagePage[];
}

const languagePagesModule: Module<LanguagePagesState, RootState> = {
  namespaced: true,

  state: (): LanguagePagesState => ({
    languagePages: [],
  }),

  getters: {
    getById: (state) => (idLanguagePage: number): LanguagePage | undefined => {
      return state.languagePages.find(languagePage => languagePage.idLanguagePage === idLanguagePage);
    },
  },

  mutations: {
    setLanguagePages(
      state,
      payload: { languagePages: Record<number, any> }
    ) {
      state.languagePages = Object
        .values(payload.languagePages)
        .map(raw => LanguagePage.fromRaw(raw));
    },

    setLanguagePageCreate(
      state,
      payload: {
        idLanguagePage: number;
        name: string;
      }
    ) {
      const languagePage = new LanguagePage(
        payload.idLanguagePage,
        payload.name,
        false,
      );
      state.languagePages.push(languagePage);
    },

    setLanguagePageDelete(
      state,
      payload: { idLanguagePage: number }
    ) {
      state.languagePages = state.languagePages.filter(
        languagePage => languagePage.idLanguagePage !== payload.idLanguagePage
      );
    },
  },

  actions: {
    wsSetLanguagePages({ commit }, payload) {
      commit('setLanguagePages', payload);
    },
    wsLanguagePageCreate({ commit }, payload) {
      commit('setLanguagePageCreate', payload);
    },
    wsLanguagePageDelete({ commit }, payload) {
      commit('setLanguagePageDelete', payload);
    },
  },
};

export default languagePagesModule;
